import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import useSessionStoreContext from '../../Contexts/SessionStoreContextProvider/useSessionStoreContext';
import EndSessionDialog from './EndSessionDialog';
import EndSessionDialogErrorFallback from './EndSessionDialog/EndSessionDialogErrorFallback';

export default function EndSessionDialogWrapper({ children }: { children: React.ReactNode }) {
  const [endSessionDialogOpen, setEndSessionDialogOpen] = React.useState<string | null>(null);
  const { sessionId: [sessionId] } = useSessionStoreContext();
  const sessionIdRef = React.useRef(sessionId);

  React.useEffect(() => {
    if (sessionId !== null && sessionId !== sessionIdRef.current) {
      setEndSessionDialogOpen(null);
    }
    if (sessionIdRef.current && !sessionId) {
      setEndSessionDialogOpen(sessionIdRef.current);
    }
    sessionIdRef.current = sessionId;
  }, [sessionId]);

  return (
    <>
      {children}
      <ErrorBoundary
        // eslint-disable-next-line react/no-unstable-nested-components
        FallbackComponent={(fallbackProps) => (
          <EndSessionDialogErrorFallback
            {...fallbackProps}
            sessionId={endSessionDialogOpen}
            onClose={() => { setEndSessionDialogOpen(null); }}
          />
        )}
        onError={(error: Error) => {
          console.error('Error rendering end session dialog', error);
        }}
        resetKeys={[endSessionDialogOpen]}
      >
        <EndSessionDialog open={endSessionDialogOpen} onClose={() => { setEndSessionDialogOpen(null); }} />
      </ErrorBoundary>
    </>
  );
}
